<app-airport-picker
  #airportPicker
  [headerTitle]="
    selectionType() === SelectionType.from ? 'Chọn điểm đi' : 'Chọn điểm đến'
  "
  (selected)="onSelectAirport($event)"
></app-airport-picker>

<app-flight-datepicker
  #flightDatepicker
  [headerTitle]="
    selectionType() === SelectionType.from ? 'Chọn ngày đi' : 'Chọn ngày về'
  "
  (selected)="onSelectDate($event)"
></app-flight-datepicker>

@if (dataForm) {
  <ng-container [formGroup]="dataForm">
    <div
      ngbAutoFocus
      class="tw-rounded-lg tw-p-3.5 tw-px-0 tw-text-secondary-content ml:tw-px-3.5"
      [ngClass]="{ 'sm:tw-bg-search-form': !showInSidebar() }"
    >
      <div class="tw-flex tw-flex-col sm:tw-flex-col-reverse">
        <!-- begin::Airports -->
        <div class="tw-mb-5 tw-grid tw-grid-cols-12 sm:tw-mb-2">
          <div class="tw-col-span-5">
            <div
              class="tw-flex tw-flex-col tw-rounded-md tw-bg-secondary-800 tw-p-[0.3125rem] tw-shadow-[inset_0_0_8px_-4px_#0000009c] active:tw-brightness-105 sm:tw-bg-transparent sm:tw-p-0 sm:tw-shadow-none"
              appBlurOnClick
              (click)="onOpenAirportPicker(SelectionType.from, airportPicker)"
            >
              <label
                class="tw-mb-[0.3125rem] tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-l-full tw-text-base/relaxed tw-text-base-400 sm:tw-mb-0 sm:tw-justify-start sm:tw-px-4 sm:tw-py-1.5 sm:tw-text-xs sm:tw-uppercase sm:tw-text-base-50"
              >
                Điểm đi
              </label>
              <div
                class="tw-just tw-flex tw-w-full tw-min-w-0 tw-grow tw-cursor-pointer tw-flex-col-reverse tw-items-center tw-text-ellipsis tw-rounded-full tw-px-4 tw-text-[0.9375rem] tw-text-base-50 tw-outline-none sm:tw-h-[3.125rem] sm:tw-flex-row sm:tw-gap-1 sm:tw-bg-base-50 sm:tw-text-base-800 lg:tw-text-base xl:tw-text-[1.0625rem]"
              >
                <span class="tw-text-base sm:tw-text-[length:inherit]">
                  {{ f["from"].value?.city }}
                </span>
                <span
                  class="tw-text-[2rem] tw-font-bold sm:tw-text-[length:inherit] sm:tw-font-normal"
                >
                  <span class="tw-hidden sm:tw-inline">(</span>
                  <span>{{ f["from"].value?.code }}</span>
                  <span class="tw-hidden sm:tw-inline">)</span>
                </span>
              </div>
            </div>
          </div>

          <div class="tw-col-span-2">
            <div class="tw-flex tw-h-full tw-flex-col">
              <button
                class="tw-hidden tw-w-full tw-cursor-pointer tw-items-center tw-rounded-l-full tw-px-4 tw-py-1.5 tw-text-xs tw-uppercase sm:tw-flex"
                (click)="onSwapAirport()"
              >
                &nbsp;
              </button>
              <button
                class="tw-m-auto tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-border-current tw-p-2 tw-text-lg tw-transition-all active:tw-scale-95 sm:tw-border-0 sm:tw-text-base"
                (click)="onSwapAirport()"
              >
                <i class="fa-solid fa-right-left"></i>
              </button>
            </div>
          </div>

          <div class="tw-col-span-5">
            <div
              class="tw-flex tw-flex-col tw-rounded-md tw-bg-secondary-800 tw-p-[0.3125rem] tw-shadow-[inset_0_0_8px_-4px_#0000009c] active:tw-brightness-105 sm:tw-bg-transparent sm:tw-p-0 sm:tw-shadow-none"
              appBlurOnClick
              (click)="onOpenAirportPicker(SelectionType.to, airportPicker)"
            >
              <label
                class="tw-mb-[0.3125rem] tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-l-full tw-text-base/relaxed tw-text-base-400 sm:tw-mb-0 sm:tw-justify-start sm:tw-px-4 sm:tw-py-1.5 sm:tw-text-xs sm:tw-uppercase sm:tw-text-base-50"
              >
                Điểm đến
              </label>
              <div
                class="tw-just tw-flex tw-w-full tw-min-w-0 tw-grow tw-cursor-pointer tw-flex-col-reverse tw-items-center tw-text-ellipsis tw-rounded-full tw-px-4 tw-text-[0.9375rem] tw-text-base-50 tw-outline-none sm:tw-h-[3.125rem] sm:tw-flex-row sm:tw-gap-1 sm:tw-bg-base-50 sm:tw-text-base-800 lg:tw-text-base xl:tw-text-[1.0625rem]"
              >
                <span class="tw-text-base sm:tw-text-[length:inherit]">
                  {{ f["to"].value?.city }}
                </span>
                <span
                  class="tw-text-[2rem] tw-font-bold sm:tw-text-[length:inherit] sm:tw-font-normal"
                >
                  <span class="tw-hidden sm:tw-inline">(</span>
                  <span>{{ f["to"].value?.code }}</span>
                  <span class="tw-hidden sm:tw-inline">)</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- end::Airports -->

        <!-- begin::Options -->
        <div class="tw-mb-2.5 tw-hidden tw-gap-5 tw-px-2.5 sm:tw-flex">
          <label class="tw-flex tw-cursor-pointer tw-items-center tw-gap-2">
            <input
              type="radio"
              formControlName="roundTrip"
              [value]="false"
              class="tw-relative tw-inline-block tw-size-5 tw-min-h-5 tw-min-w-5 tw-cursor-pointer tw-appearance-none tw-rounded-full tw-bg-base-50 after:tw-transition-all after:checked:tw-absolute after:checked:tw-inset-0 after:checked:tw-m-auto after:checked:tw-size-2.5 after:checked:tw-rounded-full after:checked:tw-bg-primary"
            />
            <span>Một chiều</span>
          </label>

          <label class="tw-flex tw-cursor-pointer tw-items-center tw-gap-2">
            <input
              type="radio"
              formControlName="roundTrip"
              [value]="true"
              class="tw-relative tw-inline-block tw-size-5 tw-min-h-5 tw-min-w-5 tw-cursor-pointer tw-appearance-none tw-rounded-full tw-bg-base-50 after:tw-transition-all after:checked:tw-absolute after:checked:tw-inset-0 after:checked:tw-m-auto after:checked:tw-size-2.5 after:checked:tw-rounded-full after:checked:tw-bg-primary"
            />
            <span>Khứ hồi</span>
          </label>
        </div>

        <div class="tw-mb-5 sm:tw-hidden">
          <div
            class="tw-relative tw-flex tw-rounded-full tw-border-4 tw-border-base-50 tw-bg-base-50 tw-text-base tw-uppercase tw-text-base-400 tw-shadow-md"
          >
            <label
              class="tw-z-10 tw-w-1/2 tw-cursor-pointer tw-rounded-full tw-py-2.5 tw-text-center tw-transition-all has-[:checked]:tw-text-primary-content"
            >
              <input
                type="radio"
                formControlName="roundTrip"
                [value]="false"
                class="tw-hidden"
              />
              <span>Một chiều</span>
            </label>

            <label
              class="tw-z-10 tw-w-1/2 tw-cursor-pointer tw-rounded-full tw-py-2.5 tw-text-center tw-transition-all has-[:checked]:tw-text-primary-content"
            >
              <input
                type="radio"
                formControlName="roundTrip"
                [value]="true"
                class="tw-hidden"
              />
              <span>Khứ hồi</span>
            </label>

            <div
              class="tw-absolute tw-left-0 tw-h-full tw-w-1/2 tw-rounded-full tw-bg-primary tw-transition-all"
              [ngClass]="{
                'tw-left-1/2': dataForm.get('roundTrip')?.value,
              }"
            >
              <!-- background transition -->
            </div>
          </div>
        </div>
        <!-- end::Options -->
      </div>

      <!-- begin::Dates -->
      <div class="tw-mb-5 tw-grid tw-grid-cols-12 sm:tw-mb-2">
        <div class="tw-col-span-5">
          <div
            class="tw-flex tw-w-full tw-flex-col tw-rounded-lg tw-bg-base-50 tw-transition-all active:tw-brightness-105 sm:tw-bg-transparent"
            appBlurOnClick
            (click)="
              onOpenFlightDatePicker(SelectionType.from, flightDatepicker)
            "
          >
            <label
              class="tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-t-md tw-bg-neutral tw-px-4 tw-py-1.5 tw-text-base sm:tw-justify-start sm:tw-bg-transparent sm:tw-text-xs sm:tw-uppercase"
            >
              Ngày đi
            </label>
            <div
              class="tw-grid tw-grow tw-cursor-pointer tw-grid-cols-[1fr,5fr] tw-grid-rows-2 tw-items-center tw-rounded-full tw-px-0.5 tw-py-3 tw-text-[1.0625rem] tw-text-secondary tw-outline-none ms:tw-grid-cols-2 ms:tw-px-4 sm:tw-flex sm:tw-h-[3.125rem] sm:tw-bg-base-50 sm:tw-text-[0.9375rem] sm:tw-text-base-800 lg:tw-text-base xl:tw-text-[1.0625rem]"
            >
              <span
                class="tw-row-span-2 tw-me-1 tw-justify-self-end tw-text-[2.875rem] tw-font-bold sm:tw-me-0 sm:tw-text-[length:inherit] sm:tw-font-normal"
              >
                {{ f["date"].value | date: "dd" }}
              </span>
              <span
                class="tw-self-end tw-leading-none sm:tw-hidden sm:tw-leading-normal"
              >
                {{ f["date"].value | date: "EEEE" }}
              </span>
              <span
                class="tw-self-start tw-leading-none sm:tw-self-center sm:tw-leading-normal"
              >
                /<span>{{ f["date"].value | date: "MM" }}</span
                >/<span>{{ f["date"].value | date: "yyyy" }}</span>
              </span>
            </div>
          </div>
        </div>

        <div class="tw-col-span-5 tw-col-start-8">
          <div
            class="tw-flex tw-w-full tw-flex-col tw-rounded-lg tw-bg-base-50 tw-transition-all active:tw-brightness-105 sm:tw-bg-transparent [&.disabled]:tw-pointer-events-none [&.disabled]:tw-opacity-20"
            [class.disabled]="!f['roundTrip'].value"
            appBlurOnClick
            (click)="
              f['roundTrip'].value &&
                onOpenFlightDatePicker(SelectionType.to, flightDatepicker)
            "
          >
            <label
              class="tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-t-md tw-bg-neutral tw-px-4 tw-py-1.5 tw-text-base sm:tw-justify-start sm:tw-bg-transparent sm:tw-text-xs sm:tw-uppercase"
            >
              Ngày về
            </label>
            <div
              class="tw-grid tw-grow tw-cursor-pointer tw-grid-cols-[1fr,5fr] tw-grid-rows-2 tw-items-center tw-rounded-full tw-px-0.5 tw-py-3 tw-text-[1.0625rem] tw-text-secondary tw-outline-none ms:tw-grid-cols-2 ms:tw-px-4 sm:tw-flex sm:tw-h-[3.125rem] sm:tw-bg-base-50 sm:tw-text-[0.9375rem] sm:tw-text-base-800 lg:tw-text-base xl:tw-text-[1.0625rem]"
            >
              <span
                class="tw-row-span-2 tw-me-1 tw-justify-self-end tw-text-[2.875rem] tw-font-bold sm:tw-me-0 sm:tw-text-[length:inherit] sm:tw-font-normal"
              >
                {{ f["returnDate"].value | date: "dd" }}
              </span>
              <span
                class="tw-self-end tw-leading-none sm:tw-hidden sm:tw-leading-normal"
              >
                {{ f["returnDate"].value | date: "EEEE" }}
              </span>
              <span
                class="tw-self-start tw-leading-none sm:tw-self-center sm:tw-leading-normal"
              >
                /<span>{{ f["returnDate"].value | date: "MM" }}</span
                >/<span>{{ f["returnDate"].value | date: "yyyy" }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- end::Dates -->

      <!-- begin::Passengers -->
      <div class="tw-mb-5 tw-grid tw-grid-cols-12 tw-gap-3">
        <div
          class="tw-col-span-4"
          [ngClass]="{
            'md:tw-col-span-3': !showInSidebar(),
          }"
        >
          <label
            for="passengerAdult"
            class="tw-block tw-cursor-pointer tw-overflow-hidden tw-text-nowrap tw-px-0.5 tw-py-1.5 tw-text-center tw-text-base ms:tw-px-4 sm:tw-text-start sm:tw-text-xs sm:tw-uppercase"
          >
            Người lớn
          </label>
          <div class="tw-relative">
            <span
              class="tw-pointer-events-none tw-absolute tw-left-4 tw-top-2/4 -tw-translate-y-2/4 tw-text-lg tw-text-primary"
            >
              <i class="fa-solid fa-male"></i>
            </span>
            <select
              formControlName="adult"
              id="passengerAdult"
              class="tw-h-[3.125rem] tw-w-full tw-cursor-pointer tw-appearance-none tw-rounded-full tw-bg-select tw-bg-no-repeat tw-ps-[48%] tw-text-[1.0625rem] tw-text-gray-700 tw-outline-none sm:tw-text-[0.9375rem] lg:tw-text-base xl:tw-text-[1.0625rem]"
            >
              <option [ngValue]="1">1</option>
              <option [ngValue]="2">2</option>
              <option [ngValue]="3">3</option>
              <option [ngValue]="4">4</option>
              <option [ngValue]="5">5</option>
              <option [ngValue]="6">6</option>
              <option [ngValue]="7">7</option>
              <option [ngValue]="8">8</option>
              <option [ngValue]="9">9</option>
            </select>
          </div>
        </div>

        <div
          class="tw-col-span-4"
          [ngClass]="{
            'md:tw-col-span-3': !showInSidebar(),
          }"
        >
          <label
            for="passengerChild"
            class="tw-block tw-cursor-pointer tw-overflow-hidden tw-text-nowrap tw-px-0.5 tw-py-1.5 tw-text-center tw-text-base ms:tw-px-4 sm:tw-text-start sm:tw-text-xs sm:tw-uppercase"
          >
            Trẻ em (2-11)
          </label>
          <div class="tw-relative">
            <span
              class="tw-pointer-events-none tw-absolute tw-left-4 tw-top-2/4 -tw-translate-y-2/4 tw-text-lg tw-text-primary"
            >
              <i class="fa-solid fa-child"></i>
            </span>
            <select
              formControlName="child"
              id="passengerChild"
              class="tw-h-[3.125rem] tw-w-full tw-cursor-pointer tw-appearance-none tw-rounded-full tw-bg-select tw-bg-no-repeat tw-ps-[48%] tw-text-[1.0625rem] tw-text-gray-700 tw-outline-none sm:tw-text-[0.9375rem] lg:tw-text-base xl:tw-text-[1.0625rem]"
            >
              <option [ngValue]="0">0</option>
              <option [ngValue]="1">1</option>
              <option [ngValue]="2">2</option>
              <option [ngValue]="3">3</option>
              <option [ngValue]="4">4</option>
              <option [ngValue]="5">5</option>
            </select>
          </div>
        </div>

        <div
          class="tw-col-span-4"
          [ngClass]="{
            'md:tw-col-span-3': !showInSidebar(),
          }"
        >
          <label
            for="passengerInfant"
            class="tw-block tw-cursor-pointer tw-overflow-hidden tw-text-nowrap tw-px-0.5 tw-py-1.5 tw-text-center tw-text-base ms:tw-px-4 sm:tw-text-start sm:tw-text-xs sm:tw-uppercase"
          >
            Em bé (<2)
          </label>
          <div class="tw-relative">
            <span
              class="tw-pointer-events-none tw-absolute tw-left-4 tw-top-2/4 -tw-translate-y-2/4 tw-text-lg tw-text-primary"
            >
              <i class="fa-solid fa-baby"></i>
            </span>
            <select
              formControlName="infant"
              id="passengerInfant"
              class="tw-h-[3.125rem] tw-w-full tw-cursor-pointer tw-appearance-none tw-rounded-full tw-bg-select tw-bg-no-repeat tw-ps-[48%] tw-text-[1.0625rem] tw-text-gray-700 tw-outline-none sm:tw-text-[0.9375rem] lg:tw-text-base xl:tw-text-[1.0625rem]"
            >
              <option [ngValue]="0">0</option>
              <option [ngValue]="1">1</option>
              <option [ngValue]="2">2</option>
              <option [ngValue]="3">3</option>
              <option [ngValue]="4">4</option>
              <option [ngValue]="5">5</option>
            </select>
          </div>
        </div>

        <div
          class="tw-col-span-12"
          [ngClass]="{
            'md:tw-col-span-3': !showInSidebar(),
          }"
        >
          <div
            class="tw-cursor-pointer tw-px-4 tw-text-xs tw-uppercase md:tw-py-1.5"
          >
            &nbsp;
          </div>
          <button
            class="tw-h-[3.125rem] tw-w-full tw-select-none tw-rounded-full tw-text-center tw-text-base tw-uppercase tw-transition-colors tw-duration-150 hover:tw-bg-rose-600 sm:tw-text-[0.9375rem] lg:tw-ps-0 lg:tw-text-base lg:active:tw-bg-rose-500"
            (click)="onSearch()"
            [ngClass]="{
              'tw-bg-rose-500': !searchService.isLoading(),
              'tw-pointer-events-none tw-bg-primary-600':
                searchService.isLoading(),
            }"
          >
            @if (searchService.isLoading()) {
              <app-dot-loader [type]="2"></app-dot-loader>
            } @else {
              <span>Tìm kiếm</span>
            }
          </button>
        </div>
      </div>
      <!-- end::Passengers -->
    </div>
  </ng-container>
}
